import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

export default function CTASection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = sectionRef.current?.querySelectorAll('.reveal-on-scroll');
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="w-full px-4 sm:px-6 lg:px-8 py-20 md:py-28 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="reveal-on-scroll bg-gradient-to-br from-primary-100/60 to-accent-100/60 border border-background-200/70 rounded-3xl p-10 sm:p-16 text-center">
          <h2 className="font-heading text-3xl sm:text-4xl font-bold mb-4 text-primary-500">
            Ready to Clear the Fog?
          </h2>
          <p className="text-foreground-600 max-w-lg mx-auto mb-8 font-body leading-relaxed">
            Join the ClearMind Club community and start building simple habits for a sharper, calmer mind.
          </p>
          <Link
            to="/community"
            className="reveal-on-scroll animation-delay-100 inline-flex items-center justify-center gap-2 whitespace-nowrap font-label font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 disabled:pointer-events-none disabled:opacity-50 bg-accent-500 text-foreground-950 hover:bg-accent-700 h-12 rounded-lg text-base px-8"
          >
            Join the Community
          </Link>
        </div>
      </div>
    </section>
  );
}